import { Dialog, RadioGroup } from '@headlessui/react'
import React, { useEffect, useState } from 'react'
import { BsBrowserChrome } from 'react-icons/bs'
import { FaApple } from 'react-icons/fa'
import { GrAndroid } from 'react-icons/gr'
import { toast } from 'react-toastify'
import {
  DeActivateCred,
  activateCred,
  addCred,
  addCredComplete,
  addNewDevice,
  getcred,
} from '../Api'
import DashboardLayout from '../components/ui/DashboardLayout'
import Loading from '../components/ui/Loading'
import { devURL } from '../utils'

const options = [
  { name: 'Browser', icon: BsBrowserChrome },
  { name: 'Android', icon: GrAndroid },
  { name: 'iOS', icon: FaApple },
]
const instructions = {
  Browser: [
    'Open the browser on your device and go to the following link',
    'Login to your account and go to the settings page',
    'Click on the add new device button',
  ],
  Android: [
    'Open the app on your device and login to your account',
    'Go to the settings page and click on the add new device button',
    'Follow the instructions on the screen to add a new device',
  ],
  iOS: [
    'Open the app on your device and login to your account',
    'Go to the settings page and click on the add new device button',
    'Follow the instructions on the screen to add a new device',
  ],
}

export default function Cred() {
  const token = localStorage.getItem('swToken')
  const [transactionData, setTransactionData] = useState([])
  const [loader, isLoading] = useState(true)
  const [isOpen, setIsOpen] = useState(false)
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const [newCred, setNewCred] = useState({})

  console.log(transactionData)

  useEffect(() => {
    getTransactionData()
    getNewRequests().then(async (res) => {
      let data = await res.json()
      setNewCred(data)
      console.log(data)
      if (data?.name) {
        setTransactionData((prev) => [
          ...prev,
          {
            new: true,
            ...data,
          },
        ])
      }
    })
  }, [])

  const getTransactionData = async () => {
    isLoading(true)
    const res = await getcred({})
    setTransactionData((prev) =>
      [prev.find((data) => data.new), ...res].filter(Boolean)
    )
    isLoading(false)
  }

  const refetch = async () => {
    setTransactionData([])
    getTransactionData()
  }

  const getNewRequests = async () => {
    const res = await fetch(`${devURL}/dfns/cred/new-request`, {
      headers: {
        token: token,
      },
    })
    return res
  }

  const handleActivate = async (uuid) => {
    isLoading(true)
    await activateCred(uuid)
    await getTransactionData()
    isLoading(false)
  }

  const handleDeActivate = async (uuid) => {
    isLoading(true)
    console.log(uuid)
    await DeActivateCred(uuid)
    await getTransactionData()
    isLoading(false)
  }

  return (
    <DashboardLayout>
      {loader ? (
        <Loading />
      ) : (
        <div className='flex justify-center mx-auto lg:block'>
          <div className='flex-grow min-h-full'>
            <div className='block lg:flex justify-around'>
              <div className='text-xl font-bold mt-2 lg:-ml-0'>
                <p className='page-title'>Linked Devices</p>
              </div>
            </div>
            <div className='flex justify-center my-2'>
              <button
                onClick={() => setIsOpen(true)}
                className='group relative py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
              >
                Add New Device
              </button>
            </div>

            <div className='flex justify-center lg:block'>
              <div className='transaction-table mt-8 ml-2 lg:mr-6 lg:ml-0'>
                <table className='table-fixed w-4/5 lg:w-[60%] relative mx-auto'>
                  <thead className='border-b'>
                    <tr>
                      <th className='text-left text-gray-400 py-5 text-xs lg:text-sm'>
                        Name
                      </th>
                      <th className='text-left text-gray-400 py-5 pl-2 text-xs lg:text-sm'>
                        Status
                      </th>
                      <th className='text-left pl-12 text-gray-400 py-5 text-xs lg:text-sm'>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactionData.length > 0 && (
                      <>
                        {transactionData.map((transaction, index) => (
                          <tr
                            key={'transaction-table-' + index}
                            className='relative'
                          >
                            <td className='py-2 text-xs lg:text-sm max-w-xs truncate text-left w-40 text-gray-800'>
                              {transaction.name}
                            </td>

                            <td className='py-2 text-xs lg:text-sm text-center text-gray-800 w-16 rounded-r-lg'>
                              <p
                                className={
                                  transaction.isActive
                                    ? 'sw-completed'
                                    : 'sw-initiated'
                                }
                              >
                                {transaction.isActive ? 'true' : 'false'}
                              </p>
                            </td>

                            {transaction.new === true && (
                              <td className='py-2 pl-6 text-xs lg:text-sm text-left text-gray-800'>
                                <button
                                  className='py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                                  onClick={() => {
                                    addCred(transaction).then((res) => {
                                      if (res.error)
                                        return toast.error(res.error)
                                      toast.success(
                                        'Device confirmed successfully, continue on other device'
                                      )
                                    })
                                  }}
                                >
                                  Confirm
                                </button>
                              </td>
                            )}

                            {transaction.new === true ||
                            (transaction.isActive &&
                              (transaction.name === 'Default Credential' ||
                                transaction.name ===
                                  'Default Recovery Credential')) ? (
                              <></>
                            ) : transaction.isActive &&
                              transaction.name !== 'Default Credential' ? (
                              <td className='py-2 pl-6 text-xs lg:text-sm text-left text-gray-800'>
                                <button
                                  className='group relative py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-700 hover:bg-themeHover'
                                  onClick={() =>
                                    handleDeActivate(transaction.credentialUuid)
                                  }
                                >
                                  De-Activate
                                </button>
                              </td>
                            ) : (
                              <td className='py-2 pl-6 text-xs lg:text-sm text-left text-gray-800'>
                                <button
                                  className='group relative py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                                  onClick={() =>
                                    handleActivate(transaction.credentialUuid)
                                  }
                                >
                                  Activate
                                </button>
                              </td>
                            )}
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      <AddNewDialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setIsConfirmOpen={setIsConfirmOpen}
        setNewCred={setNewCred}
      />
      <ConfirmNewCredentialDialog
        isOpen={isConfirmOpen}
        setIsOpen={setIsConfirmOpen}
        data={newCred}
        refetch={refetch}
      />
    </DashboardLayout>
  )
}

function AddNewDialog({ isOpen, setIsOpen, setIsConfirmOpen, setNewCred }) {
  const token = localStorage.getItem('swToken')
  const [name, setName] = useState()
  const [selected, setSelected] = useState(options[0])
  const [showInstructions, setShowInstructions] = useState(false)

  const handleNext = async () => {
    if (!name) {
      return toast.error('Please enter a name')
    }
    const res = await addNewDevice(name, selected.name)
    if (res.error) {
      return toast.error(res.error)
    }
    setShowInstructions(true)
    // start polling
    const interval = setInterval(async () => {
      const res = await fetch(`${devURL}/dfns/cred/new-request`, {
        headers: {
          token: token,
        },
      })
      if (!res.ok) {
        clearInterval(interval)
        return toast.error('Something went wrong')
      }
      const data = await res.json()
      console.log(data)
      if (data.data) {
        setNewCred(data)
        clearInterval(interval)
        setIsOpen(false)
        setShowInstructions(false)
        setIsConfirmOpen(true)
        return toast.success('Please confirm the device')
      }
      if (data.status === 'not initiated') {
        clearInterval(interval)
        setIsOpen(false)
      }
    }, 5000)
  }

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        if (!showInstructions) {
          setIsOpen(false)
          setShowInstructions(false)
        }
      }}
    >
      <div className='fixed inset-0 bg-black/30' aria-hidden='true' />
      <div className='fixed inset-0 flex w-screen items-center justify-center p-4'>
        <Dialog.Panel className='bg-white py-4 px-6 rounded'>
          <Dialog.Title className='text-3xl font-bold'>
            Add new device
          </Dialog.Title>

          {!showInstructions ? (
            <>
              <Dialog.Description>
                Select the platform you want to add
              </Dialog.Description>
              <div className='flex flex-col my-2'>
                <label htmlFor='name' className='text-sm'>
                  Name the device
                </label>
                <input
                  type='text'
                  id='name'
                  onChange={(e) => {
                    setName(e.target.value)
                  }}
                  placeholder='iPhone 12'
                  className='form-control relative w-3/5 lg:w-4/5 px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none'
                />
              </div>
              <div className='flex gap-4 my-2'>
                <RadioGroup
                  value={selected}
                  onChange={setSelected}
                  className='flex gap-4 my-2'
                >
                  {options.map((option) => (
                    <RadioGroup.Option
                      key={option.name}
                      value={option}
                      className={({ active, checked }) =>
                        `h-[120px] w-[120px] border flex flex-col justify-center items-center rounded cursor-pointer
                      ${
                        active
                          ? 'ring-2 ring-offset-2 ring-offset-light-blue-300 ring-white ring-opacity-60'
                          : ''
                      }
                        ${
                          checked
                            ? 'bg-themeColor border-transparent text-white hover:bg-themeColor/90'
                            : 'bg-white'
                        }`
                      }
                    >
                      {({ checked }) => (
                        <>
                          <option.icon
                            className={`text-4xl ${
                              checked ? 'text-white' : 'text-black'
                            }`}
                          />
                          {option.name}
                        </>
                      )}
                    </RadioGroup.Option>
                  ))}
                </RadioGroup>
              </div>

              <div className='flex justify-end'>
                <button
                  onClick={() => setIsOpen(false)}
                  className='py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md border-red-700 text-red-700 bg-white hover:bg-red-700 hover:text-white'
                >
                  Cancel
                </button>
                <button
                  className='py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                  onClick={() => handleNext()}
                >
                  Next
                </button>
              </div>
            </>
          ) : (
            <>
              <Dialog.Description className='text-sm text-red-600'>
                Please don't close this browser window until you have completed
                the process
              </Dialog.Description>
              <ul className='space-y-1 mt-2'>
                {instructions[selected.name].map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
              <div className='flex justify-end mt-2'>
                <button
                  onClick={() => {
                    setShowInstructions(false)
                    setIsOpen(false)
                  }}
                  className='py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md border-red-700 text-red-700 bg-white hover:bg-red-700 hover:text-white'
                >
                  Cancel
                </button>
              </div>
            </>
          )}
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}

function ConfirmNewCredentialDialog({ isOpen, setIsOpen, data, refetch }) {
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setIsOpen(false)
      }}
    >
      <div className='fixed inset-0 bg-black/30' aria-hidden='true' />
      <div className='fixed inset-0 flex w-screen items-center justify-center p-4'>
        <Dialog.Panel className='bg-white py-4 px-6 rounded'>
          <Dialog.Title className='text-3xl font-bold'>
            Confirm new device
          </Dialog.Title>
          <Dialog.Description>
            Do you want to add this device to your account?
          </Dialog.Description>
          <div className='my-2 space-y-1'>
            <p>Name: {data.name}</p>
            <p>Platform: {data.device}</p>
            <p>location: {data.location}</p>
          </div>
          <div className='flex justify-end my-2'>
            <button
              onClick={() => setIsOpen(false)}
              className='py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md border-red-700 text-red-700 bg-white hover:bg-red-700 hover:text-white'
            >
              Cancel
            </button>
            <button
              className='py-1 mt-1 px-4 ml-2 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
              onClick={() =>
                addCredComplete(data).then((res) => {
                  if (res.error) return toast.error(res.error)
                  setIsOpen(false)
                  toast.success('Device added successfully')
                  refetch()
                })
              }
            >
              Confirm
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}
